exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".contact-form-container{position:fixed;top:100px;right:0;transform:translateX(100%);transition:transform .5s ease-in-out;z-index:1000}.contact-form-container.open{transform:translateX(0)}.contact-form-container .contact-toggle{position:absolute;background:var(--client-secondary);width:50px;height:575px;left:-50px;display:flex;align-items:center;justify-content:center;border:none;color:#fff;font-size:14px;white-space:nowrap;cursor:pointer;transition:left .5s ease-in-out}.contact-form-container .contact-toggle .toggle-text{transform:rotate(-90deg)}.contact-form{background:#f8f8f8;width:400px;height:575px;padding:25px 15px}.contact-form .contact-title{color:var(--client-secondary);text-align:center;margin-bottom:30px;font-weight:500!important}.contact-form .text-fields{display:grid;grid-template-columns:1fr 1fr;gap:10px;border-radius:5px}.contact-form input,.contact-form select,.contact-form textarea{margin:5px 0;padding:5px;border:1px solid #ccc;border-radius:3px}.contact-form input,.contact-form textarea{width:100%}.contact-form textarea{height:75px}.contact-form .form-success{color:#007a00}@media (max-width:480px){.contact-form{width:300px}}", ""]);

// exports
exports.locals = {
	"ingleprimary": "#004687",
	"inglesecondary": "#f07d00",
	"rimiprimary": "#3a17c5",
	"rimisecondary": "#3a17c5",
	"msgprimary": "#961a1a",
	"msgsecondary": "#961a1a",
	"visitcanadaprimary": "#3498DB",
	"visitcanadasecondary": "#3498DB",
	"insurecanadaprimary": "#146ab5",
	"insurecanadasecondary": "#146ab5"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./src/styles/contact-us.scss
// module id = 1087
// module chunks = 0